"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
function getVariablesOfferLetter(move, configuration, consultant, calculation, offer) {
    var _a, _b;
    return {
        kunde: util_1.getAddressVariables(move.customer),
        beladestelle: move.loadingAddresses.length > 0
            ? move.loadingAddresses.map((ba) => ba.city).join("/")
            : move.customer.city,
        entladestelle: move.unloadingAddresses.map((ea) => ea.city).join("/"),
        datum: move.loadingDates
            .map((d) => util_1.formatDate(d.date))
            .filter((d) => !!d)
            .join(" / "),
        alternativDatum: move.loadingDates
            .map((d) => util_1.formatDate(d.alternateDate))
            .filter((d) => !!d)
            .join(" / "),
        angebotsdatum: util_1.formatDate((_b = (_a = move.documentData) === null || _a === void 0 ? void 0 : _a.offer) === null || _b === void 0 ? void 0 : _b.date),
        preisNetto: offer.total,
        preisBrutto: offer.totalGross,
        versicherungZeitwert: calculation.totalVolume * 620,
        versicherungAnteil: configuration.calculationParameters.insuranceFactor * 100,
        versicherungMindestbeitrag: configuration.calculationParameters.insuranceMinimum,
        zeitraum: move.loadingDates
            .map((d) => util_1.ensureDate(d.date))
            .filter((d) => !!d)
            .map((d) => util_1.formatTimespan(d, 30))
            .join(" / "),
        packmaterialAnlieferungDatum: move.loadingDates
            .map((d) => util_1.formatDate(d.packingMaterialDate))
            .filter((d) => !!d)
            .join(" / ") || 0,
        unterschrift: util_1.getSignature(consultant),
        kundenrabatt: offer.absoluteDiscount,
        kundenrabattProzent: offer.relativeDiscount,
    };
}
exports.default = getVariablesOfferLetter;
//# sourceMappingURL=offerLetter.js.map